module.exports = __webpack_public_path__ + "static/media/click.abdf6b6b.mp3";